module.exports = {
	"en": {
		"allTerminals": "All terminals",
		"allOptions": "All options",
		"allTime": "All time",
		"answer": "Answer",
		"by": "By",
		"byDayOfWeek": "By day of week",
		"byHourOfDay": "By hour of day",
		"byOption": "By option",
		"byTag": "By tag",
		"npsByDeviceTag": "NPS by device tag",
		"byTerminal": "By terminal",
		"comment": "Comment",
		"clearSelection": "Clear selection",
		"clearSelectedSubjects": "Clear selected subjects",
		"clearTags": "Clear tags",
		"custom": "Custom",
		"date": "Date",
		"dayOfWeek": "Day of week",
		"detractors": "Detractors",
		"error.couldNotFetch": "Something went wrong and data couldn't be fetched from the server. Please email <a href=\"mailto:support@touchandtell.se\" target=\"_blank\">support@touchandtell.se</a> if the problem persists.",
		"error.missingQueryVariables": "Required variables are missing from the widget's query to the servers, so data couldn't be fetched. Please email <a href=\"mailto:support@touchandtell.se\" target=\"_blank\">support@touchandtell.se</a> if the problem persists.",
		"exportPdf": "Export PDF",
		"foreignVisitors": "Foreign visitors",
		"filterBySubject": "Filter by subject",
		"hourOfDay": "Hour of day",
		"lastMonth": "Last month",
		"lastWeek": "Last week",
		"lastYear": "Last year",
		"loading": "Loading",
		"logOut": "Log out",
		"moreCommentsAvailable": "Not all comments for the selected date range could be loaded. To export all comments, please create several exports with more narrow date ranges.",
		"no": "No",
		"noAnswersInDateRange": "No answers have been collected during the selected dates.",
		"nps": "Net Promoter Score",
		"npsByAnswerToOtherQuestion": "Net Promoter Score",
		"numberOfAnswers": "{count} {count, plural, =0 {No answers} one {answer} other {answers}}",
		"numberOfAnswersPerTerminal": "Number of answers per terminal",
		"numberOfReports": "{count} {count, plural, one {report} other {reports}}",
		"occurrences": "Occurrences",
		"other": "Other",
		"passives": "Passives",
		"promoters": "Promoters",
		"score": "Score",
		"scoreByAnswerToOtherQuestion": "Score",
		"selectedTags": "Selected tags",
		"tags": "Tags",
		"terminal": "Terminal",
		"terminals": "Terminals",
		"thisMonth": "This month",
		"thisWeek": "This week",
		"thisYear": "This year",
		"time": "Time",
		"today": "Today",
		"week": "Week",
		"yes": "Yes",
		"last90Days": "Last 90 days",
		"csat": "CSAT",
		"agreeQuestionType-completelyAgree": "I totally agree",
		"agreeQuestionType-agree": "I somewhat agree",
		"agreeQuestionType-disagree": "I do not agree",
		"agreeQuestionType-completelyDisagree": "I strongly disagree",
		"agreeQuestionType-noAnswer": "Unable to answer"
	},
	"sv": {
		"allTerminals": "Alla terminaler",
		"allOptions": "Alla alternativ",
		"allTime": "Alla svar",
		"answer": "Svar",
		"by": "Per",
		"byDayOfWeek": "Per veckodag",
		"byHourOfDay": "Per timma på dagen",
		"byOption": "Per svarsalternativ",
		"byTag": "Per tagg",
		"npsByDeviceTag": "NPS per enhetstagg",
		"byTerminal": "Per terminal",
		"comment": "Kommentar",
		"clearSelection": "Rensa val",
		"clearSelectedSubjects": "Rensa markerade val",
		"clearTags": "Rensa taggar",
		"custom": "Eget val",
		"date": "Datum",
		"dayOfWeek": "Veckodag",
		"detractors": "Kritiker",
		"error.couldNotFetch": "Någonting gick fel och data kunde inte hämtas från servern. Vänligen maila <a href=\"mailto:support@touchandtell.se\" target=\"_blank\">support@touchandtell.se</a> om problemet inte försvinner.",
		"error.missingQueryVariables": "En eller flera variabler fattades i widgetens query till servern, så data kunde inte hämtas. Vänligen maila <a href=\"mailto:support@touchandtell.se\" target=\"_blank\">support@touchandtell.se</a> om problemet inte försvinner.",
		"exportPdf": "Exportera PDF",
		"foreignVisitors": "Utländska besökare",
		"filterBySubject": "Filtrera på ämne",
		"hourOfDay": "Timma på dagen",
		"lastMonth": "Förra månaden",
		"lastWeek": "Förra veckan",
		"lastYear": "Förra året",
		"loading": "Laddar",
		"logOut": "Logga ut",
		"moreCommentsAvailable": "Alla kommentarer för detta datumintervall kunde inte laddas samtidigt. För att exportera alla kommentarer, vänligen skapa flera exporter med kortare datumintervall.",
		"no": "Nej",
		"noAnswersInDateRange": "Inga svar har kommit in under den valda tidsperioden.",
		"nps": "Net Promoter Score",
		"npsByAnswerToOtherQuestion": "Net Promoter Score",
		"numberOfAnswers": "{count} {count, plural, =0 {Inga svar} other {svar}}",
		"numberOfAnswersPerTerminal": "Antal svar per terminal",
		"numberOfReports": "{count} {count, plural, one {rapport} other {rapporter}}",
		"occurrences": "Antal",
		"other": "Övriga",
		"passives": "Passiva",
		"promoters": "Ambassadörer",
		"score": "Betyg",
		"scoreByAnswerToOtherQuestion": "Betyg",
		"selectedTags": "Valda taggar",
		"tags": "Taggar",
		"terminal": "Terminal",
		"terminals": "Terminaler",
		"thisMonth": "Denna månad",
		"thisWeek": "Denna vecka",
		"thisYear": "Detta året",
		"time": "Tid",
		"today": "Idag",
		"week": "Vecka",
		"yes": "Ja",
		"last90Days": "Senaste 90 dagarna",
		"csat": "CSAT",
		"agreeQuestionType-completelyAgree": "Jag instämmer helt",
		"agreeQuestionType-agree": "Jag håller med lite",
		"agreeQuestionType-disagree": "Jag håller inte med",
		"agreeQuestionType-completelyDisagree": "Jag håller inte starkt med",
		"agreeQuestionType-noAnswer": "Kan inte svara"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/localeData.json
// module id = 1360
// module chunks = 0